<template lang="pug">
    // h1 Detalle Lote
    v-container( fluid )
        .lock-screen(v-if="lockScreen")
        v-layout( row wrap )
            v-flex( xs12 ma-2 )
                v-toolbar( color="grey darken-4" dark )
                    v-toolbar-title Solicitudes de despacho en lote
                    v-spacer
                    v-toolbar-items(v-if="showButtonToBill")
                        v-btn( color="grey darken-3" depressed @click="submitToBill" ) 
                            v-icon.mr-2 description 
                            span Facturar
                v-data-table(
                    :headers="headers"
                    :items="items"
                    hideActions
                    ref="refDTable"
                    )
                    template(slot="items" slot-scope="props")
                        td {{ props.item.wh_dispatch_request_id }}
                        td {{ props.item.wh_dispatch_request.sl_customer.alias_name }}
                        td {{getCustomerOfficeText(props.item.wh_dispatch_request)}}
                        td {{ props.item.wh_dispatch_request.creation_date }}
                        td {{getPaymentConditionText(props.item.wh_dispatch_request)}}
                        td {{ props.item.wh_dispatch_request.g_state.state }}
                        td {{ props.item.wh_dispatch_request.wh_dispatch_request_document_status.status }}
</template>

<script>
import CrudDataTable from '@/components/CrudDataTable/CrudDataTable'
import BatchDetailsHeaders from './BatchDetailsHeaders'
import DispatchRequestBatchService from '@/services/API/dispatchRequestBatch/fetchDataTable'
import DispatchRequestService from '@/services/API/dispatchRequest/DispatchRequestServices'
//- Model
import { generateFetchDataFunction } from '@/services/API/DataTableService'
import DispReqBatchModel from '@/models/Warehouse/WhDispatchRequestBatch'
import DRBIncludes from '@/services/API/dispatchRequestBatch/DispatchRequestBatchIncludes'
//-
import { mapActions, mapState } from 'vuex'
import Axios from 'axios'

export default {
    name: 'batch-detail',
    props: {},
    data: function() {
        return {
            headers: BatchDetailsHeaders,
            items: [],
            selectedIdBatch: null,
            showButtonToBill: false,
            listOfDispatch: [],
            lockScreen: false,
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        ...mapState('SessionModule', ['pchPaymentConditions']),
    },
    methods: {
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        ...mapActions('CashDeskModule', {
            printVoucher: 'printVoucher',
            reprintDTE: 'reprintDTE',
        }),
        getPaymentConditionText(dispatch_request) {
            try {
                return this.pchPaymentConditions.find(
                    cond =>
                        cond.id === dispatch_request.pch_payment_condition_id
                ).type
            } catch (e) {
                return '-'
            }
        },
        getCustomerOfficeText(dispatch_request) {
            let office = dispatch_request.sl_customer_branch_offices
            return (
                `${office.g_commune ? office.g_commune.name + ' - ' : ''}` +
                office.address
            )
        },
        submitToBill: function() {
            //
            this.resetSnackbarState()
            this.setMessageConfirmSnack('Facturar')
            //
            let payload = this.fillSnack(
                'warning',
                '¿Facturar solicitudes de despacho?',
                'Lote por despachar con solicitudes facturadas'
            )
            this.initSnackbar(payload)
        },
        setShowButtonToBill: function(showButtonToBill) {
            this.showButtonToBill = showButtonToBill
        },
        showLoadingSnack(message) {
            this.resetSnackbarState()
            this.initSnackbar(
                this.fillSnack('info', 'Cargando...', message, true)
            )
        },
        fillTable: async function() {
            this.selectedIdBatch = this.$route.params.id
            const customerInfo = await DispatchRequestBatchService.fetchById(
                this.$route.params.id
            )
            console.log('info: ', customerInfo)
            this.items = customerInfo.wh_details_dispatch_request_batch
            console.log('items: ', this.items)
            //-
            let arrayState = this.items.map(
                item =>
                    item.wh_dispatch_request
                        .wh_dispatch_request_document_status_id
            )

            console.log('array states: ', arrayState)
            //-
            let largeArray = arrayState.find(arr => {
                if (arr == 3) {
                    //no facturado
                    this.setShowButtonToBill(true)
                    return arr
                } else this.setShowButtonToBill(false)
            })
            console.log('large array: ', largeArray)
        },
        downloadAllInvoicePdfs(dtes) {
            let promises = dtes.map(
                ({ dte }) =>
                    new Promise((resolve, reject) =>
                        Axios.get(
                            process.env.VUE_APP_API_ROUTE +
                                '/sl_sale_invoice/' +
                                dte.id +
                                '/pdf',
                            { responseType: 'blob' }
                        )
                            .then(response => {
                                const linkSource = URL.createObjectURL(
                                    response.data
                                )
                                const downloadLink = document.createElement('a')
                                const fileName = `${dte.number}-FACTURA_ELECTRONICA.pdf`
                                downloadLink.href = linkSource
                                downloadLink.download = fileName
                                downloadLink.click()
                                resolve()
                            })
                            .catch(reject)
                    )
            )
            return Promise.all(promises)
        },
    },
    watch: {
        async responseConfirm(val) {
            //-
            if (val === 'Facturar') {
                //-
                this.resetSnackbarState()
                const obj = {
                    details: this.items.map(item => ({
                        wh_dispatch_request_id: item.wh_dispatch_request_id,
                    })),
                }
                let dispReqToBill = null

                this.lockScreen = true
                this.showLoadingSnack('Facturando solicitudes de despacho')

                try {
                    dispReqToBill = await DispatchRequestService.posDispatchRequestToBill(
                        obj
                    )
                } catch (e) {
                    this.lockScreen = false
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        e &&
                            e.response &&
                            e.response.data &&
                            e.response.data.error
                            ? e.response.data.error
                            : e.response &&
                              e.response.data &&
                              e.response.data.message
                            ? e.response.data.message
                            : 'Ha ocurrido un error'
                    )
                    this.initSnackbar(payload)
                    return
                }
                if (dispReqToBill.status == 'success') {
                    let payload = this.fillSnack(
                        'success',
                        'Solicitudes facturadas.',
                        ''
                    )
                    this.initSnackbar(payload)
                    if (
                        dispReqToBill.dtes.some(({ dte }) => !dte.url_file_dte)
                    ) {
                        this.showLoadingSnack(
                            'Descargando archivos PDF de las facturas'
                        )
                        this.downloadAllInvoicePdfs(dispReqToBill.dtes)
                            .then(() => {
                                let payload = this.fillSnack(
                                    'success',
                                    'Facturas Impresas',
                                    'Facturas impresas exitosamente'
                                )
                                this.initSnackbar(payload)
                            })
                            .catch(e => {
                                let payload = this.fillSnack(
                                    'error',
                                    'Error en Impresión',
                                    e &&
                                        e.response &&
                                        e.response.data &&
                                        e.response.data.error
                                        ? e.response.data.error
                                        : e.response &&
                                          e.response.data &&
                                          e.response.data.message
                                        ? e.response.data.message
                                        : 'Ha ocurrido un error'
                                )
                                this.initSnackbar(payload)
                            })
                            .finally(() => {
                                this.lockScreen = false
                                this.$router.push('/bill_batch_list')
                            })
                    } else {
                        //add actions print
                        let dtes_url = dispReqToBill.dtes
                        dtes_url.forEach(element => {
                            this.printVoucher(element.url_file_dte)
                        })
                        this.lockScreen = false
                    }
                    this.$router.push('/bill_batch_list')
                } else {
                    this.lockScreen = false
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        dispReqToBill.error
                    )
                    this.initSnackbar(payload)
                }
            }
        },
    },
    components: {
        'crud-data-table': CrudDataTable,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: function() {
        this.fillTable()
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
.lock-screen {
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 12;
    background-color: rgba($color: #aaaaaa, $alpha: 0.5);
    cursor: wait;
}
</style>
